import React, { useEffect, useState } from 'react';

import { Autocomplete, Button, Typography } from '@mui/material';
import * as MATERIEL_ICONS from '@mui/icons-material/';

import { assignment_fields } from '../constants/create_assignment_fields';
import CustomInput from '../../../../components/CustomInput';
import service from '../service';
import { toast } from 'react-toastify';
import { useBoundStore } from '../../../../stores';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';
import Switch from '@mui/material/Switch';
import { useNavigate } from 'react-router-dom';

function CreateAssignmentDrawer() {

  const toggleRightDrawer = useBoundStore((state) => state.toggleRightDrawer);
  const navigate = useNavigate();
  const [valid, setValid] = useState(false);
  const [products, setProducts] = useState([]);
  const [devices, setDevices] = useState([]);
  const [users, setUsers] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [sameUser, setSameUser] = useState(true);


  const [filterCompany, setFilterCompany] = useState({ companyName: '' });
  const [filterDevice, setFilterDevice] = useState({ param: '' });
  const [filterUser, setFilterUser] = useState({ param: '' });
  const [filterProduct, setFilterProduct] = useState({ param: '' });

  const [assignmentFormData, setAssignmentFormData] = useState({
    appointedName: '',
    appointedSurname: '',
    appointedPhonenumber: '',
    companyId: {},
    userId: {},
    productId: {},
    deviceId: {},
  });

  const validateForm = () => {
    if (
      assignmentFormData.companyId.id
    ) {
      setValid(true);
    } else {
      setValid(false);
    }
  };

  const handleSave = async () => {
    await service.saveAssignment({
      appointedName: assignmentFormData.appointedName,
      appointedSurname: assignmentFormData.appointedSurname,
      appointedPhonenumber: assignmentFormData.appointedPhonenumber,
      userId: sameUser ? {
        id: JSON.parse(localStorage.getItem('user')).id
      } : assignmentFormData.userId,
      ...assignmentFormData?.productId?.id ? { productId: assignmentFormData.productId } : null,
      ...assignmentFormData?.deviceId?.id ? { deviceId: assignmentFormData.deviceId } : null,
      ...assignmentFormData?.companyId?.id ? { companyId: assignmentFormData.companyId } : null,
    }).then((response) => {
      if (response?.status === 200 || response?.status === 201) {
        toast.success('Atama başarıyla oluşturuldu.');
      } else {
        toast.error('Atama oluşturulurken hata oluştu.');
      }
      toggleRightDrawer();
      navigate("/definitions/assignments")
    });
  };

  const getCompanies = async () => {
    const params = {
      ...filterCompany,
      size: 10,
      page: 0,
      sort: `createdAt,desc`,
    };
    await service.getCompanyWithSearch(params).then((response) => {
      if (response?.status === 200) {
        setCompanies(response.data.content);
      }
    });
  }

  const getDevices = async () => {
    const params = {
      ...filterDevice,
      size: 10,
      page: 0,
      sort: `createdAt,desc`,
    };

    await service.getDevicesWithSearch(params).then((response) => {
      if (response?.status === 200) {
        setDevices(response.data.content);
      }
    });
  }

  const getUsers = async () => {
    const params = {
      ...filterUser,
      size: 10,
      page: 0,
      sort: `createdAt,desc`,
    };
    await service.getUserWithSearch(params).then((response) => {
      if (response?.status === 200) {
        setUsers(response.data.content);
      }
    });
  }

  const getProducts = async () => {
    const params = {
      ...filterProduct,
      size: 10,
      page: 0,
      sort: `createdAt,desc`,
    };
    await service.getProductWithSearch(params).then((response) => {
      if (response?.status === 200) {
        setProducts(response.data.content);
      }
    });
  }

  const handleFilterCompany = (value) => {
    setFilterCompany({ ...filterCompany, companyName: value });
  }

  const handleFilterDevice = (value) => {
    setFilterDevice({ ...filterDevice, param: value });
  }

  const handleFilterUser = (value) => {
    setFilterUser({ ...filterUser, param: value });
  }

  const handleFilterProduct = (value) => {
    setFilterProduct({ ...filterProduct, param: value });
  }

  useEffect(() => {
    validateForm();
  }, [assignmentFormData]);


  useEffect(() => {
    getCompanies();
  }, [filterCompany]);

  useEffect(() => {
    getDevices();
  }, [filterDevice]);

  useEffect(() => {
    getUsers();
  }, [filterUser]);

  useEffect(() => {
    getProducts();
  }, [filterProduct]);

  return (
    <div className="mt-5">
      <div className="px-2">
        <Typography variant="h6">Atama Ekle</Typography>
      </div>
      <div>
        <>
          <div>
            <div className="flex flex-row flex-wrap justify-center items-center gap-4 w-full my-5">
              {assignment_fields().map((field, index) => {
                return (
                  <div className=" flex w-full" key={index}>
                    <CustomInput
                      key={index}
                      type={field.type}
                      inputType={field.inputType}
                      defaultValue={field.defaultValue}
                      items={field.items}
                      label={field.placeHolder}
                      value={assignmentFormData[field.key]}
                      fullWidth={true}
                      size={'small'}
                      onChange={(key, value) => {
                        setAssignmentFormData({
                          ...assignmentFormData,
                          [field.key]: value,
                        });
                      }}
                    />
                  </div>
                );
              })}
              <Autocomplete
                fullWidth
                options={companies || []}
                getOptionLabel={(option) => option?.companyName}
                onChange={(e, option) => {
                  setAssignmentFormData({
                    ...assignmentFormData,
                    companyId: {
                      id: option?.id
                    }
                  });
                }}
                onInputChange={(e, value) => { handleFilterCompany(value); }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Teslim Edilen Şirket*"
                    variant="outlined"
                    size="small"
                  />
                )}
              />

              <Autocomplete
                fullWidth
                options={devices}
                getOptionLabel={(option) => option?.imei}
                onChange={(e, option) => {
                  setAssignmentFormData({
                    ...assignmentFormData,
                    deviceId: {
                      id: option?.id
                    }
                  });
                }}
                onInputChange={(e, value) => { handleFilterDevice(value); }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Teslim Edilen Cihaz"
                    variant="outlined"
                    size="small"
                  />
                )}
              />

              <Autocomplete
                fullWidth
                options={products}
                getOptionLabel={(option) => option?.productName}
                onChange={(e, option) => {
                  setAssignmentFormData({
                    ...assignmentFormData,
                    productId: {
                      id: option?.id
                    }
                  });
                }}
                onInputChange={(e, value) => { handleFilterProduct(value); }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Teslim Edilen Ürün"
                    variant="outlined"
                    size="small"

                  />
                )}
              />
              <div className="w-full flex justify-start items-center">
                <Switch
                  checked={sameUser}
                  onChange={(e) => setSameUser(e.target.checked)}
                  color="primary"

                />
                <span className=''>Teslimi gerçekleştiren kişi, mevcut kullanıcı.</span>
              </div>
              {
                !sameUser ? (
                  <Autocomplete
                    fullWidth
                    options={users}
                    getOptionLabel={(option) => option?.username}
                    onChange={(e, option) => {
                      setAssignmentFormData({
                        ...assignmentFormData,
                        userId: {
                          id: option?.id
                        }
                      });
                    }}
                    onInputChange={(e, value) => { handleFilterUser(value); }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Teslim Eden Kullanıcı"
                        variant="outlined"
                        size="small"

                      />
                    )}
                  />
                ) : (
                  null
                )
              }

              <Button
                disabled={!valid}
                variant="contained"
                color="primary"
                startIcon={<MATERIEL_ICONS.Save />}
                onClick={() => handleSave()}
                className="mx-2"
              >
                Kaydet
              </Button>
            </div>
          </div>
        </>

      </div>
    </div >
  );
}

export default CreateAssignmentDrawer;
